module.exports = __webpack_public_path__ + "static/media/583.50da0147.webp";